import { useMediaQuery } from '@ag1/ui';
import { useDeferredSessionValue } from '@portal/appLayer/auth';
import { menuNavigationEvent } from 'analytics/events/studio';
import dynamic from 'next/dynamic';
import { SimpleFooterMenuItem } from 'types/studio/footer';
import FooterMenuLink from '../FooterMenuLink/FooterMenuLink';

import styles from './styles.module.scss';

const FooterMenuItemCollapsible = dynamic(
  () => import('../FooterMenuItemCollapsible/FooterMenuItemCollapsible'),
  {
    ssr: false
  }
);

const FooterMenuItem = (linkItem: SimpleFooterMenuItem) => {
  const session = useDeferredSessionValue();
  const customer = session?.customer;
  const atLarge = useMediaQuery('l', -1);

  if (atLarge !== -1 && !atLarge) {
    return <FooterMenuItemCollapsible {...linkItem} />;
  }

  const sendNavigationEvent = (label: string) =>
    menuNavigationEvent({
      location: 'footer',
      header: linkItem?.title || '',
      clickText: label
    });

  return (
    <section className={styles.root}>
      <h3 className={styles.title}>{linkItem?.title || ''}</h3>
      <ul className={styles.list}>
        {linkItem?.links
          .filter(({ link }) => !!link)
          .map((childLink) =>
            (childLink.customerOnly && !!customer?.id) || // Show for logged-in customers only
            (childLink.newCustomerOnly && !customer) || // Show for logged-out customers only
            (!childLink.customerOnly && !childLink.newCustomerOnly) ? ( // Show for all users
              <li
                key={childLink.label}
                className={styles.item}
                onClick={() => sendNavigationEvent(childLink.label)}
                onKeyDown={() => sendNavigationEvent(childLink.label)}>
                <FooterMenuLink {...childLink} />
              </li>
            ) : null
          )}
      </ul>
    </section>
  );
};

export default FooterMenuItem;
